import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../environments/environment'

@Injectable()
export class AdminService {

  defaultOptions = {
    withCredentials: true
  }

  constructor(private http: HttpClient) { }

  isAuthorized() {
    return this.http
      .get(environment.apiBaseUrl + 'admin', this.defaultOptions)
  }

  login(username: string, password: string) {
    return this.http
      .post(environment.apiBaseUrl + 'admin', { username, password }, this.defaultOptions)
  }

}



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/shared/services/admin/admin.service.ts